@if (showAddOption()) {
  <div class="flex items-center gap-3 mb-2">
    <h3 class="m-0 text-title-2 text-surface-700">Setup Options</h3>
    @if (!isReadonly()) {
      <p-button
        class="ml-auto"
        icon="pi pi-plus"
        label="Add Option"
        [disabled]="isLocked()"
        (onClick)="openAddOptionDialog(); $event.stopPropagation()"
      />
    }
  </div>
}

@if (products().length > 0) {
  <div class="pt-0">
    <div class="flex flex-col gap-4">
      @for (product of products(); track product.id) {
        <div
          [attr.id]="'addendum-option-' + product.id"
          class="relative shadow-module rounded-2xl p-4 transition-colors"
          [class.cursor-pointer]="!isReadonly()"
          [class.option-editing]="!isReadonly() && selectedProductId() === product.id"
          [class.bg-white]="!product.isExpanded"
          [class.hover:bg-surface-50]="!product.isExpanded && !isReadonly()"
          [ngClass]="{ 'bg-gray-200/20': product.isExpanded }"
          (click)="$event.stopPropagation(); onProductSelect(product.id)"
        >
          <div class="flex items-center gap-2.5">
            <dsm-aps-addendum-product-preview
              class="flex flex-wrap flex-1 min-w-0 items-center"
              [addendum]="dealAddendum()"
              [product]="product"
              [isMismatchedLocation]="mismatchedProductIds().has(product.id)"
              [isReplacementTriggerExecuted]="executedTriggerProductIds().has(product.productId)"
              [isReadonly]="isReadonly()"
              [isEditing]="!isReadonly() && selectedProductId() === product.id"
              (onChanges)="onChanges.emit()"
            />
            @if (product.linkedProducts.length) {
              <span
                class="inline-flex cursor-pointer text-surface-500 hover:text-surface-700 w-8 h-8 items-center justify-center shrink-0"
                (click)="$event.stopPropagation(); product.isExpanded = !product.isExpanded"
              >
                <i
                  class="pi text-body-sm leading-none"
                  [class.pi-chevron-up]="product.isExpanded"
                  [class.pi-chevron-down]="!product.isExpanded"
                ></i>
              </span>
            }
          </div>
          @if (product.linkedProducts.length && product.isExpanded) {
            <p-divider />
            <div>
              <h3 class="mb-3 text-title-2 text-surface-700">Kit Options</h3>
              <div class="flex flex-col gap-4">
                @for (linkedProduct of product.linkedProducts; track linkedProduct.id) {
                  <div
                    [attr.id]="'addendum-option-' + linkedProduct.id"
                    class="relative shadow-module rounded-2xl p-4 bg-white transition-colors"
                    [class.cursor-pointer]="!isReadonly()"
                    [class.hover:bg-surface-50]="!isReadonly()"
                    [class.option-editing]="!isReadonly() && selectedProductId() === linkedProduct.id"
                    [ngClass]="{ 'bg-gray-200/20': product.isExpanded }"
                    (click)="$event.stopPropagation(); onKitProductSelect(linkedProduct.id)"
                  >
                    <dsm-aps-addendum-product-preview
                      class="flex flex-wrap items-center w-full"
                      [isKitLinkedProduct]="true"
                      [addendum]="dealAddendum()"
                      [product]="linkedProduct"
                      [isMismatchedLocation]="mismatchedProductIds().has(linkedProduct.id)"
                      [isReplacementTriggerExecuted]="executedTriggerProductIds().has(linkedProduct.productId)"
                      [isReadonly]="isReadonly()"
                      [isEditing]="!isReadonly() && selectedProductId() === linkedProduct.id"
                      (onChanges)="onChanges.emit()"
                    />
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <div class="flex flex-wrap items-center justify-center text-center border border-slate-200 rounded-md p-4 gap-2 mt-3">
    <p class="text-body-sm mb-0 text-slate-700">There are no options, start by adding options</p>
    <!-- <p-button
      icon="pi pi-plus"
      label="Add Option"
      [disabled]="isLocked()"
      (onClick)="openAddOptionDialog(); $event.stopPropagation()"
    /> -->
  </div>
}

<p-drawer
  [visible]="addOptionDialogVisible()"
  (visibleChange)="addOptionDialogVisible.set($event)"
  [fullScreen]="true"
  [modal]="true"
  [blockScroll]="true"
  appendTo="body"
  styleClass="add-option-drawer"
  [style]="{ width: '100%', height: '100%' }"
>
  <ng-template pTemplate="header">
    <div class="flex items-center gap-2 w-full">
      <div class="flex flex-col gap-0.5 min-w-0">
        <div class="flex items-center gap-2 flex-wrap">
          <span class="text-title-1 text-surface-700">Add New Option(s)</span>
          <button
            type="button"
            class="lg:!hidden relative inline-flex items-center justify-center w-8 h-8 rounded-full border cursor-pointer transition-colors"
            [ngClass]="
              filtersVisible()
                ? 'border-primary-500 bg-primary-500 text-white'
                : 'border-surface-300 bg-white text-surface-500 hover:border-primary-500 hover:text-primary-500 hover:bg-primary-50'
            "
            (click)="toggleFilters()"
          >
            <i class="text-sm pi pi-sliders-h"></i>
            @if (activeFilterCount() > 0) {
              <span
                class="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full bg-orange-500 text-white text-[12px] font-semibold leading-none"
              >
                {{ activeFilterCount() }}
              </span>
            }
          </button>
        </div>
        <div class="flex flex-wrap pt-1">
          <span class="text-body-xs-600 text-surface-500">{{ headerSummary() }}</span>
        </div>
      </div>
    </div>
  </ng-template>

  @if (addOptionDialogVisible()) {
    <dsm-add-option-modal
      class="block h-full min-h-0"
      [modelId]="modelId()"
      [elevationId]="elevationId()"
      [addendumId]="dealAddendum().id"
      [lotId]="dealAddendum().lotId"
      [addedProductIds]="addedProductIds()"
      [addedProducts]="products()"
      [(filtersVisible)]="filtersVisible"
      (submitted)="onOptionsSaved($event)"
      (dialogClose)="addOptionDialogVisible.set(false)"
    />
  }
</p-drawer>

<p-dialog
  header="Plan-changing option added"
  [visible]="planChangeWarningMessage() !== null"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
  appendTo="body"
  [style]="{ width: 'min(92vw, 32rem)' }"
>
  <p class="m-0 text-body-sm text-surface-700">{{ planChangeWarningMessage() }}</p>
  <ng-template pTemplate="footer">
    <p-button label="OK" (onClick)="acknowledgePlanChangeWarning()" />
  </ng-template>
</p-dialog>
